<template>
    <div class="modal fade modal-flex" id="dailyBonusModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
        <div class="modal-dialog" style="width: 365px; max-width: 365px;">
            <div class="modal-content" style="padding-bottom: 15px;">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">{{ $t('lisa_web_claim_success') }}</h5>
                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
                </div>
                <div class="modal-body">
                    <div class="welcome-back">
                        <!-- <img src="/themes/web/assets/images/achivement.svg" alt="" /> -->
                        <AppIcon :src="$store.state.treasure_icon_url" :size="150" />

                        <div class="welcome-back-content">
                            <!-- <span id = "congratulation_gem" class="modal-title" style="vertical-align: bottom;">+0</span> <i class="lisa-icon-gem-large-2" style="vertical-align: middle;"></i> -->
                            <span id = "congratulation_gem" class="modal-title" style="vertical-align: bottom; font-size: 40px; font-weight: 800;">+{{ user.dailybonus_gemreward }}</span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-main-sm m-auto" @click="claim" style="padding: 8px 40px;">OK</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {claimDailyBonus} from "../../models/reward";
    import {soundClick, soundGetReward, soundClaimTreasure} from '../../utils/utils';
    import AppIcon from "@/components/common/AppIcon.vue";

    export default {
        name: "DailyBonusModal",
        components: { AppIcon },
        props: ['user'],

        watch: {
            $route() {
                this.$nextTick(function () {
                    if (this.user.first_login == 1) {
                        $('#dailyBonusModal').modal('show');
                    }
                })  
            },
        },

        computed:{
            hide_popup() {
                return this.$store.state.hide_popup;
            },
            is_lasted() {
                return this.$store.state.is_lasted;
            },
            eventPopup() {
                return this.$store.state.event_popup;
            },
        },

        created() {
            this.$nextTick(function () {
                if (this.user.first_login == 1 && true) {
                    $('#dailyBonusModal').modal('show');
                }
            })            
            
        },

        methods: {
            claim() {
                const that = this;

                that.getSoundClick();

                that.$store.commit("setLoading", true);

                claimDailyBonus().then((response) => {
                    that.$store.commit("setLoading", false);

                    const gem_reward = response.data.results.gem_reward || 0;
                    const new_gem = response.data.results.update_gem || 0;

                    that.user.gem = new_gem;

                    const gem_txt = gem_reward >= 0 ? '+' + gem_reward : '-' + gem_reward;

                    //that.getSoundClaimTreasure();

                    $('#congratulation_gem').text(gem_txt);
                    $('#dailyBonusModal').modal("hide");
                    $('#getRewardedModal').modal();
                    this.$store.commit("setClaim", true);
                    this.$emit('updateFirstLogin', 0)
                    if(this.is_lasted){
                        $('#popupContinueLesson').modal('show')
                    }
                }).catch((response) => {
                    that.$store.commit("setLoading", false);

                    console.error(response);
                });
            },

            getSoundClick() {
                soundClick();
            },

            getSoundGetReward() {
                soundGetReward();
            },
            getSoundClaimTreasure() {
                soundClaimTreasure();
            }
        }
    }
</script>

<style scoped>
    .modal-content{
        background: url(/public/themes/ito/images/paper-flower.svg) no-repeat top;
        background-color: white;
        border-radius: 10px;
        height: 350px;
        width: 300px;
    }
    #staticBackdropLabel{
        font-weight: 900;
    }
</style>
